import { groupBy } from "./../utils";
import axios from "axios";
import { API } from "../../constants";

// fetch total number of students
export const getStudentCount = () => {
  return axios.get(API + "items/student_profile?meta=filter_count&limit=0");
};
// fetch total number of teachers
export const getTeacherCount = () => {
  return axios.get(API + "items/teacher_profile?meta=filter_count&limit=0");
};
// fetch app usages(to calculate total app usage)
export const getAppUsagesData = () => {
  return axios.get(
    API + "items/app_usage?fields=id,time_in_min,usage_on,user&limit=-1"
  );
};

/*
 *** TEACHER DASHBOARD STATS ***
 */

// get total student count for particular teacher based on grade section list that the teacher is assigned
export const getStudentCountForTeacher = (gradeList: number[]) => {
  return axios.get(
    API +
      `items/student_profile_grade_section?filter[grade_section_id][in]=${gradeList.join(
        ","
      )}&limit=0&meta=filter_count`
  );
};

// fetch all students for particular grade-section
export const getAllStudentsForParticularGradeSection = (
  gradeSectionId: number
) => {
  return axios.get(
    API +
      `items/student_profile_grade_section?filter[grade_section_id]=${gradeSectionId}&fields=student_profile_id.user`
  );
};

// fetch grade wise performance for teacher
export const getGradeSectionWisePerformance = (
  grade_section_id: number,
  grade_id: number
) => {
  return axios.get(
    API +
      `custom/stats_admin/grade_section/classPerformance?grade_section=${grade_section_id}&grade_id=${grade_id}`
  );
};

// fetch grade-section based app performance data
export const getGradeSectionWiseAppUsagesData = (studentList) => {
  return axios.get(
    API +
      `items/app_usage?filter[user][in]=${studentList?.join(
        ","
      )}&fields=id,time_in_min,usage_on,user&limit=-1`
  );
};

// fetch overall performance for a grade
export const getGradeWiseOverallProgress = (
  grade_section_id: number,
  grade_id: number
) => {
  return axios.get(
    API +
      `custom/stats_admin/grade_section/overallClassPerformance?grade_section=${grade_section_id}&grade_id=${grade_id}`
  );
  // grade_section/overallClassPerformance?grade_id=12&grade_section=5
};

/*
 *** PRINCIPAL DASHBOARD STATS ***
 */
// fetch grade wise performance for school admin(or principl)
export const getGradeWisePerformance = (grade_section_id: number, grade_id) => {
  // return axios.get(API + `custom/stats/principal/subject/classPerformance?grade=${grade_section}`);
  return axios.get(
    API +
      `custom/stats_admin/grade_section/classPerformance?grade_section=${grade_section_id}&grade_id=${grade_id}`
  );
};

// get total number of student for principal's school based on grade list
export const getStudentCountForPrincipal = (gradeList: number[]) => {
  return axios.get(
    API +
      `items/student_profile_grade_section?filter[grade_section_id][in]=${gradeList.join(
        ","
      )}&limit=0&meta=filter_count`
  );
};

// get total number of teacher for principal's school
export const getTeacherCountForPrincipal = (schoolId: number) => {
  return axios.get(
    API + `items/teacher_profile?filter[school]=1&limit=0&meta=filter_count`
  );
};

// fetch all students for particular grade-section
export const getAllStudentsForParticularGrade = (gradeSectionId: number) => {
  if (gradeSectionId) {
    return axios.get(
      API +
        `items/student_profile_grade_section?filter[grade_section_id]=${gradeSectionId}&fields=student_profile_id.user`
    );
  } else {
    return axios.get(
      API + `items/student_profile_grade_section?fields=student_profile_id.user`
    );
  }
};

// fetch grade based app performance data based on student list
export const getGradeWiseAppUsagesData = (studentList) => {
  return axios.get(
    API +
      `items/app_usage?filter[user][in]=${studentList?.join(
        ","
      )}&fields=id,time_in_min,usage_on,user&limit=-1`
  );
};

/*
 *** STATE LEVEL DASHBOARD STATS ***
 */
// dashboard stats
export const getDashboardStats = (
  session: number,
  start_date: string,
  end_date: string,
  districtId?: number,
  blockId?: number
) => {
  let groupBy = "";
  if (districtId) {
    if (blockId) {
      groupBy = "school";
    } else {
      groupBy = "block";
    }
  } else {
    groupBy = "district";
  }
  return axios.get(
    API +
      `custom/stats_admin/dashboard?group_by=${groupBy}&session=${session}&district=${
        districtId || -1
      }&block=${
        blockId || -1
      }&school=-1&start_date=${start_date}&end_date=${end_date}`
  );
};
export const getStudentAppUsageGrouped = (
  session: number,
  districtId?: number,
  blockId?: number,
  start_date?: string,
  end_date?: string
) => {
  let groupBy = districtId ? (blockId ? "school" : "block") : "district";
  return axios.get(
    `${API}custom/stats_admin/student/group/appUsage?session=${session}&grade_id=-1&grade_section_id=-1&district=${
      districtId || -1
    }&block=${blockId || -1}&school=-1&start_date=${
      start_date || -1
    }&end_date=${end_date || -1}&group_by=${groupBy}`
  );
};
export const getStudentPerformanceGrouped = (
  session: number,
  districtId?: number,
  blockId?: number
) => {
  let groupBy = districtId ? (blockId ? "school" : "block") : "district";
  return axios.get(
    `${API}custom/stats_admin/student/group/performance?session=${session}&district=${
      districtId || -1
    }&block=${blockId || -1}&school=-1&group_by=${groupBy}`
  );
};
export const getStudentProgressGrouped = (
  session: number,
  districtId?: number,
  blockId?: number
) => {
  let groupBy = districtId ? (blockId ? "school" : "block") : "district";
  return axios.get(
    `${API}custom/stats_admin/student/group/contentUsage?session=${session}&district=${
      districtId || -1
    }&block=${blockId || -1}&school=-1&group_by=${groupBy}`
    // &start_date=${
    //   start_date || -1
    // }&end_date=${end_date || -1}&group_by=${groupBy}`
  );
};

// get total number of teacher for state
export const getTeacherCountForState = () => {
  return axios.get(API + `items/teacher_profile?limit=0&meta=filter_count`);
};

// get total number of student for state
export const getStudentCountForState = () => {
  return axios.get(
    API +
      `items/student_profile?filter[user.status]=active&filter[user.srn_no][nnull]=null&limit=0&fields=*.*&meta=filter_count`
  );
};

/*
 *** PARTICULAR STUDENT STATS - Student profile ***
 */

// get student's progress of each subject
export const getProgressForAllTopic = (
  studentId: number,
  gradeId: number,
  gradeSectionId: number
) => {
  return axios.get(
    API +
      `custom/stats_admin/student/subjectPerformance?student_id=${studentId}&grade_id=${gradeId}&grade_section_id=${gradeSectionId}`
  );
};

// get student's overall material progress
export const getStudentOverallMaterialProgress = (
  userId: number,
  gradeId: number
) => {
  return axios.get(
    API +
      `custom/courseProgress/overallProgress?student_id=${userId}&grade_id=${gradeId}`
  );
};

// get leaderboard stats to get student's performance
export const getStudentLeaderboardStats = (
  studentId: number,
  gradeId: number
) => {
  return axios.get(
    API + `custom/statsLeaderboard?student_id=${studentId}&grade_id=${gradeId}`
  );
};

// fetch app usages for student(to calculate total app usage)
export const getAppUsagesDataByStudent = (userId: number) => {
  return axios.get(
    API +
      `items/app_usage?filter[user]=${userId}&fields=id,time_in_min,usage_on,user&limit=-1`
  );
};
